// extracted by mini-css-extract-plugin
export var adCard = "_p2-8";
export var adCardBorder = "_p2-5";
export var arbiterButtonIcon = "_p2-p";
export var buttonIcon = "_p2-o";
export var container = "_p2-e";
export var copyButton = "_p2-m";
export var darkGrey = "_p2-u";
export var deliveryDate = "_p2-2";
export var divider = "_p2-n";
export var editModeWrapper = "_p2-7";
export var empty = "_p2-a";
export var errorIcon = "_p2-d";
export var filledCircle = "_p2-4";
export var fulfillmentFooter = "_p2-j";
export var grey = "_p2-s";
export var header = "_p2-i";
export var headerWrapper = "_p2-h";
export var highlighted = "_p2-6";
export var historyEntry = "_p2-3";
export var mobileColumn = "_p2-v";
export var mobileColumnReverse = "_p2-w";
export var orderDetailsContainer = "_p2-g";
export var orderMetadata = "_p2-l";
export var orderMetadataWrapper = "_p2-k";
export var packagesContainer = "_p2-b";
export var product = "_p2-y";
export var productImage = "_p2-z";
export var productInfo = "_p2-x";
export var productTitle = "_p2-10";
export var strikethrough = "_p2-t";
export var tinyText = "_p2-r";
export var title = "_p2-9";
export var trackerCard = "_p2-1";
export var trackerCardWrapper = "_p2-0";
export var trackingContainer = "_p2-f";
export var trackingTitle = "_p2-c";
export var xTinyText = "_p2-q";